import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>OperatorKredytowy.pl</h3>
            <p>Profesjonalne doradztwo finansowe i najlepsze oferty kredytowe</p>
          </div>
          
          <div className="footer-section">
            <h3>Oferta</h3>
            <ul className="footer-links">
              <li><Link to="/website-structure">Struktura Strony</Link></li>
              <li><Link to="/website-pricing">Wycena Strony</Link></li>
              <li><Link to="/facebook-tiktok-ads">Facebook/TikTok Ads</Link></li>
              <li><Link to="/google-ads">Google Ads</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Kontakt</h3>
            <p>Email: kontakt@optiweb.pl</p>
            <p>Telefon: +48 792 351 155</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Optiweb.pl. Wszelkie prawa zastrzeżone.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;